<template>
    <div>
        <slot v-bind="self"/>
    </div>
</template>


<script>
// Basic Use - Covers most scenarios
// import {VueEditor} from "vue2-editor";

import {ref} from 'vue';

// Vue main app
export default({
    name: 'BulletinPage',
    props: {
        token: {
            type: String,
            required: true
        },
        countriesUrl: {
            type: String,
            required: true
        },
        standardsUrl: {
            type: String,
            required: true
        },
        editionsUrl: {
            type: String,
            required: true
        },
        responsesUrl: {
            type: String,
            required: true
        },
        fileUploadUrl: {
            type: String,
            required: false
        },
        saveUrl: {
            type: String,
            required: false
        }
    },
    data: {
        loaded: {
            countries: false,
            standards: false,
            editions: false,
            responses: false
        },
        key: '',
        style: '',
        class: '',
        hoverCol: '',
        hoverRow: '',
        countries: [],
        standards: [],
        editions: [],
        responses: [],
        showLoadingSpinner: true,
        editionsOpen: [],
        focusCountry: false,
        focusCountryShowEditions: false,
        focusStandard: false,
        focusEdition: false,
        focusResponse: false,
        focusResponseText: false,
        focusResponseIsEdition: false,
        modal: false,
        standardEditing: 0,
        editionEditing: {},
        saveResponse: {},
        connectionError: false,
        fileUploading: false,
        fullscreen: false,
        customToolbar: [
            ["bold", "italic", "underline"],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{list: "ordered"}, {list: "bullet"}],
            ["clean"]
        ],
        customToolbarLinks: [
            ["bold", "italic", "underline"],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{list: "ordered"}, {list: "bullet"}],
            ["link", "clean"]
        ]
    },
    computed: {
        self() {
            return this;
        },
        console: () => console,
        responseShowIsExtended: function () {
            return !! (this.saveResponse.Status === 'National differences');
        },
        responseShowFileUpload: function () {
            return !! (this.responseShowIsExtended && this.saveResponse.fileUploadRequired == 2 && !this.saveResponse.DocumentID);
        },
        responseShowFile: function () {
            return !! (this.responseShowIsExtended && this.saveResponse.DocumentID);
        },
        responseFileComplete: function () {
            return !! (!this.responseShowFileUpload && this.saveResponse.DocumentID);
        },
        responseShowSummary: function () {

            if (this.saveResponse.Status === 'Full') {
                return true;
            }

            if (this.responseShowIsExtended) {
                if (this.saveResponse.fileUploadRequired === '') {
                    return false;
                }
                if (this.responseShowFileUpload) {
                    return false;
                }
                if (this.responseFileComplete) {
                    return true;
                }
                return true;
            }
            return false;
        },
        responseShowFullResponse: function () {
            return !! (this.responseShowSummary && !this.saveResponse.DocumentID);
        },
        responseShowSave: function () {
            if (this.saveResponse.Status === 'Full' || this.saveResponse.Status === 'No corresponding standard') {
                return true;
            }
            if (this.responseShowSummary) {
                if (!this.saveResponse.Summary) {
                    return false;
                }
                if (!this.saveResponse.PublicResponseText) {
                    return false;
                }
                return true;
            }
            return false;
        },
        summaryRequired: function () {
            return (this.saveResponse.Status === 'National differences') ? "*" : "";
        }

    },
    mounted: function () {
        // var token = $('#app-bulletin-page').data('token');
        // var countriesUrl = $('#app-bulletin-page').data('countries-url');
        // var standardsUrl = $('#app-bulletin-page').data('standards-url');
        // var editionsUrl = $('#app-bulletin-page').data('editions-url');
        // var responsesUrl = $('#app-bulletin-page').data('responses-url');
        // var fileUploadUrl = $('#app-bulletin-page').data('file-upload-url');
        // var saveUrl = $('#app-bulletin-page').data('save-url');
        this.loadData();
    },
    methods: {
        loadData: function () {

            // this.showLoadingSpinnershowLoadingSpinner = true;
            const c_url = this.countriesUrl;
            const s_url = this.standardsUrl;
            const v_url = this.editionsUrl;
            const r_url = this.responsesUrl;

            fetch(c_url)
                .then(response => response.json())
                .then(data => {
                    this.countries = data;
                    this.loaded.countries = true;
                });

            fetch(s_url)
                .then(response => response.json())
                .then(data => {
                    this.standards = data;
                    this.loaded.standards = true;

                    for (let i = 0; i < this.standards.length; i++) {
                        this.standards[i].showEditions = false;
                    }
                });

            fetch(v_url)
                .then(response => response.json())
                .then(data => {
                    this.editions = data;
                    this.loaded.editions = true;
                });

            fetch(r_url)
                .then(response => response.json())
                .then(data => {
                    this.responses = data;
                    this.loaded.responses = true;
                });
        },

        /**
         *
         * @param {object} standard
         * @param {object} country
         * @param {string} attribute
         * @param {boolean} showUnknown - show unknown if no response
         * @return {string} response object attribute
         */
        getResponseAttributeStandard: function (standard, country, attribute, showUnknown) {
            var response = this.getResponseByStandard(standard, country);
            if (response) {
                return response[attribute];
            }
            if (showUnknown) {
                return "Unknown";
            }
            return "";
        },
        /**
         *
         * @param {object} edition
         * @param {object} country
         * @param {string} attribute
         * @param {boolean} showUnknown - show unknown if no response
         * @return {string} response object attribute
         */
        getResponseAttributeEdition: function (edition, country, attribute, showUnknown) {
            var response = this.getResponse(edition, country);
            if (response) {
                return response[attribute];
            }
            if (showUnknown) {
                return "Unknown";
            }
            return "";
        },
        /**
         * getStandardFromEdition
         * @param edition  {object]}
         * @returns {*|boolean}
         */
        getStandardFromEdition: function (edition) {
            var standard = this.standards.filter(function (el) {
                return el.id == edition.certificationStandard;
            });
            if (standard.length > 0) {
                return standard[0];
            }
            return false;
        },
        /**
         *
         * @param {object} standard
         * @param {object} country
         * @returns {object} response
         */
        getResponseByStandard: function (standard, country) {
            if (!standard.hasOwnProperty('editions')) {
                return false;
            }
            if (!standard.editions) {
                return false;
            }

            var edition = standard.editions[0];
            return this.getResponse(edition, country);
        },
        /**
         * getResponse
         * @param {object} edition
         * @param {object} country
         * @returns {object} response
         */
        getResponse: function (edition, country) {
            var response = this.responses.filter(function (el) {
                return el.certificationStandardEdition == edition.id && el.country == country.id;
            });
            if (response.length > 0) {
                return response[0];
            }
            return false;
        },
        fullNumber: function (standard) {
            if (!standard) {
                return '';
            }
            var prefix = (standard.hasOwnProperty('prefix')) ? standard.prefix : '';
            var number = (standard.hasOwnProperty('number')) ? standard.number : '';
            var part = (standard.hasOwnProperty('part')) ? standard.part : '';

            var parts = [prefix, number, part];
            return parts.join('-');
        },
        statusToIcon: function (status) {
            if (status === 'Full') {
                return 'full';
            }
            if (status === 'National differences') {
                return 'differences';
            }
            if (status === 'No corresponding standard') {
                return 'no-standard';
            }
            if (status === 'Unknown') {
                return 'unknown';
            }
            return 'unknown';
        },
        statusToClass: function (status) {
            if (status === 'Full') {
                return 'full';
            }
            if (status === 'National differences') {
                return 'national-differences';
            }
            if (status === 'No corresponding standard') {
                return 'no-standard';
            }
            if (status === 'Unknown') {
                return 'unknown';
            }
            return 'unknown';
        },
        toggleShowEditions: function (index) {
            if (this.editionsOpen.includes(index)) {
                this.editionsOpen = this.editionsOpen.filter(i => i !== index);
                return;
            }
            this.editionsOpen.push(index);
        },
        showCountry: function (country) {
            this.focusCountry = country;
            this.modal = 'country';
        },
        showStandard: function (standard) {
            this.focusStandard = standard;
            this.modal = 'standard';
        },
        /**
         * showResponse
         * @param {object} response
         * @param {object} standard
         * @param {object} edition
         * @param {object} country
         * @returns {response} response
         */
        showResponse: function (response, standard, edition, country) {
            this.focusResponse = response;
            this.focusStandard = standard;
            if (edition) {
                this.focusEdition = edition;
            }
            this.focusCountry = country;
            this.modal = 'response';
        },
        showFullResponseText: function (content) {
            this.focusResponseText = content;
        },
        editCountryResponses: function (countryid) {
            var country = this.countries.filter(function (el) {
                return el.id == countryid;
            });

            if (country) {
                this.focusCountry = country[0];
                this.modal = 'editResponses';
            }
        },
        editing: function (edition, response) {
            let status = null;
            let publicresponsetext = null;
            let responseText = null;
            let summary = null;
            // let edition = standard.editions[0];
            // let standardid = standard.id;
            this.editionEditing = edition;

            if (response) {
                status = response.status;
                summary = response.summary;
                publicresponsetext = response.publicResponseText;
                responseText = response.response;
            }

            this.saveResponse = {
                CountryID: this.focusCountry.id,
                CertificationStandardEditionID: edition.id,
                Status: status,
                Response: responseText,
                Summary: summary,
                PublicResponseText: publicresponsetext,
                DocumentID: null,
                DocumentName: null,
                DocumentSize: null,
                fileUploadRequired: ""
            };
            this.modal = 'editEditionResponse';
        },
        cancelEdit: function () {
            confirm('Are you sure you want to cancel?');
            this.resetEdit();
        },
        resetEdit: function () {
            this.standardEditing = 0;
            this.editionEditing = {};
            this.saveResponse = {};
            this.modal = 'editResponses';
        },
        saveEdit: function () {
            var type, targetid;

            if (!confirm('Save response?')) {
                return false;
            }

            if (this.connectionKey !== '') {
                var url = this.saveUrl;
                var json = this.saveResponse;

                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(json)
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json();
                    })
                    .then(data => {
                        this.connectionerror = false;
                        this.responses = data.responses;
                        this.resetEdit();
                        return true;
                    })
                    .catch(() => {
                        this.connectionError = "There was a problem saving your data. Please check your internet connection, or Reload the page";
                    });
            }
        },
        doFileUpload: function (event) {
            var type, targetid;

            if (!confirm('Upload document to save with your response?')) {
                return false;
            }

            if (this.fileUploadUrl !== '') {
                var url = this.fileUploadUrl;

                this.file = event.refs.file.files[0];

                let formData = new FormData();
                formData.append('file', this.file);
                formData.append('paramName', 'file');
                formData.append('CountryID', this.saveResponse.CountryID);
                formData.append('StandardID', this.saveResponse.StandardID);

                this.fileUploading = true;


                let promise = fetch(url, {
                    method: 'POST',
                    body: formData
                }).catch(error => {
                    alert('Error:', error);
                }).then(response => {
                    this.fileUploading = false;
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        var error = new Error('There was a problem uploading your file.  Please check the file type, size and contents and try again. ' + response.statusText);
                        error.response = response;
                        throw error;
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        this.connectionerror = false;
                        this.saveResponse.DocumentID = response.documentID;
                        this.saveResponse.DocumentSize = response.size;
                        this.saveResponse.DocumentName = response.filename;

                    }).catch(error => {
                        alert('There was a problem uploading your file.  Please check the file type, size and contents and try again. ' + error);
                    });
            }
        },
        notEditing: function (standard) {
            return (this.standardEditing && this.standardEditing !== standard.id) ? 'not-editing' : '';
        }
    }
});
</script>
